module.exports = __webpack_public_path__ + "static/apulanta3-df9ef7c1b5efe55d174dd1685b2afc17.jpg";